// extracted by mini-css-extract-plugin
export default {"container":"ManageLayout_container__BT7fq","left":"ManageLayout_left__vVB4-","right":"ManageLayout_right__c0a-B"};